import tinycolor from 'tinycolor2';

// grays
export const COLOR_BLACK = '#343434';
export const COLOR_BLACK_TWO = '#111111';
export const COLOR_BLACK_THREE = '#545454';
export const COLOR_COD_GRAY = '#171717';
export const COLOR_RICE_CAKE = '#fffdef';
export const COLOR_ALTO = '#dedede';
export const COLOR_ATHENS_GRAY = '#eeeef4';
export const COLOR_CARARRA = '#f0eeeb';
export const COLOR_DESERT_STORM = '#fafaf9';
export const COLOR_DOVE_GRAY = '#6a6a6a';
export const COLOR_SLATE_GREY = '#5a5969';
export const COLOR_GUNMETAL = '#676968';

export const COLOR_GALLERY = '#eaeaea';
export const COLOR_GALLERY_DARK = '#aeaeae';
export const COLOR_QUILL_GRAY = '#e4e4e2';
export const COLOR_MERCURY = '#e2e2e2';
export const COLOR_BLUEY_GRAY = '#99a2b8';
export const COLOR_SILVER = '#ccc';
export const COLOR_WILD_SAND = '#f6f6f6';
export const COLOR_WESTAR = '#dddbd9';
export const COLOR_VERY_LIGHT_PINK = '#f8f7f5';

export const COLOR_HOVER_BASE = '#766742';
export const COLOR_HOVER = tinycolor(COLOR_HOVER_BASE)
  .setAlpha(0.05)
  .toRgbString();

// reds
export const COLOR_TUSCANY = '#ba4c2b';
export const COLOR_BRICK_RED = '#8e1b05';
export const COLOR_REDDY_BROWN = '#751604';
export const COLOR_WARNING_RED = '#d33a4d';

// blues
export const COLOR_DANUBE = '#5698ca';
export const COLOR_NICE_BLUE = '#185cad';
export const COLOR_HAVELOCK_BLUE = '#4d92e3';
export const COLOR_LUCKY_POINT = '#1f226a';
export const COLOR_SHAKESPEARE = '#4099cf';
export const COLOR_STEEL_BLUE = '#518dc1';
export const COLOR_JELLY_BEAN = '#2774ae';
export const COLOR_CEB_HEADER_BLUE = '#003475';
export const COLOR_NIGHT_BLUE = '#070a4e';
export const COLOR_BOTTICELLI = '#c7d5e0';
export const COLOR_PALE_GREY = '#f6fbff';
export const COLOR_DARK_GREY_BLUE = '#29364f';
export const COLOR_POLO_BLUE = '#8aacd5';
// blue/green
export const COLOR_DUSTY_TEAL = '#448f78';
export const COLOR_SEA_FOAM = '#52a7b9';
export const COLOR_ICE = '#f1fff6';
export const COLOR_TEAL = '#007f80';
export const COLOR_BLUE_RIBBON = '#006df4';
export const COLOR_BLUE_STONE = '#005e5f';

// yellows
export const COLOR_BUTTERED_RUM = '#aa7e11';
export const COLOR_DI_SERRIA = '#d99b4e';
export const COLOR_RAW_SIENNA = '#cf9240';
export const COLOR_CITRINE_WHITE = '#f7f7ca';
export const COLOR_LIGHTNING_YELLOW = '#fdc028';
export const COLOR_SAFFRON = '#f5c023';
export const COLOR_ORANGEY_YELLOW = '#fdba12';
export const COLOR_GOLD = '#ffd100';
export const COLOR_CORN = '#e2b900';

export const ATTITUDE_COLORS_CAUTION = 'rgba(234, 161, 21, 1)';
export const ATTITUDE_COLORS_CONTRAST = 'rgba(234, 161, 21, 1)';
export const ATTITUDE_COLORS_CITED = 'rgba(86, 152, 202, 1)';
export const ATTITUDE_COLORS_DISCUSSED = 'rgba(86, 152, 202, 1)';
export const ATTITUDE_COLORS_NEGATIVE = 'rgba(186, 76, 43, 1)';
export const ATTITUDE_COLORS_UNKNOWN = 'rgba(90, 89, 105, 1)';
export const ATTITUDE_COLORS_WARNING = 'rgba(234, 132, 95, 1)';

export const BREAKPOINT_SMALL_HANDHELD = '320px';
export const BREAKPOINT_HANDHELD = '960px';
export const BREAKPOINT_TABLET = '1240px';

export const SELECTION_BG = 'rgba(#cfe3e6, 0.99)';
